// Modules
import React from 'react';
import moment from 'moment';

import { InvoiceLink } from 'components/widgets/icons/link-icons';
import { LONG_HUMAN_DATE_TIME_FORMAT } from 'constants';
import { ShortDate } from 'components/widgets/dates';
import AgreementMismatch from 'components/models/agreement/agreement-mismatch';
import AgreementNickname from 'components/models/agreement/agreement-nickname';
import ArchiveTimeReport from 'components/models/time-report/archive-time-report';
import ArchivedTimeReportRow from 'components/models/time-report/archived-time-report-row';
import BillableIcon from 'components/models/agreement/billable-icon';
import CompanyNickname from 'components/models/company/company-nickname';
import EditTimeReportPopup from 'components/models/time-report/forms/edit-time-report-popup';
import TicketLink from 'components/models/ticket/ticket-link';
import TimeReport from 'services/data/time-report';
import UserInitials from 'components/models/user/user-initials';


// Component
export default class TimeReportRow extends React.PureComponent {
  render() {
    const { report, eagerUpdate } = this.props;
    const billable = TimeReport.isBillable(report);
    const date = moment(report.date);
    const created = moment(report.createdAt);
    let format = 'M/D';

    if (date.isSame(created, 'day')) {
      date.hour(created.hour()).minute(created.minute());
      format = 'M/D h:mm a';
    }

    if (report.status === 'Archived') {
      return <ArchivedTimeReportRow report={report} eagerUpdate={eagerUpdate} totalCols="8" />;
    }

    return (
      <tr>
        <td className="nowrap"><ShortDate date={date} format={format} tooltipFormat={LONG_HUMAN_DATE_TIME_FORMAT} /></td>
        <td><UserInitials userId={report.createdBy} /></td>
        <td><CompanyNickname company={report.company} /></td>
        <td><AgreementNickname agreement={report.agreement} /></td>
        <td>
          <TicketLink ticket={report.ticket}>{report.ticket.description}</TicketLink>
        </td>
        <td>{report.description}</td>
        <td className="right-align">{Number(report.duration).toFixed(2)}</td>
        <td className="no-padding options-cell right-align">
          <BillableIcon afterHours={report.afterHours} billable={billable} amount={Number(report.amount)} />
          { report.invoice && <InvoiceLink className="svg-only-button" invoiceId={report.invoice} /> }
          <AgreementMismatch item={report} />
          <EditTimeReportPopup report={report} eagerUpdate={eagerUpdate} />
          <ArchiveTimeReport report={report} eagerUpdate={eagerUpdate} />
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/time-report/time-report-row.js